// Pure helpers for the "Universitet tuzilmasi" page.
//
// The page must mirror the admin panel exactly: every RectorEmployee row is a
// section, and a department belongs to the section chosen in the department's
// "Biriktirish (Rektor yoki Prorektor)" field (`responsible_person`). The API
// already nests those departments under each rector (`rector.departments`), so
// nothing here re-groups, renames, hides, or invents rows.

export const normalize = (str) =>
    str ? String(str).toLowerCase().replace(/['`’"“”]/g, "").trim() : "";

// A row is the main Rector when its admin "Status" (RectorCategory) is
// "Rektor". Rows without a status fall back to the position text: a position
// that *starts* with "Rektor" ("Rektor", "Rektor v.v.b., ...") is the rector,
// anything else ("... bo'yicha prorektor") is a pro-rector section.
export const isMainRector = (rector) => {
    const category = normalize(rector?.category?.name_uz);
    if (category) return category === "rektor";
    return normalize(rector?.position_uz).startsWith("rektor");
};

// Returns the sections to render, in admin order (the API is already ordered
// by `order`), with the main Rector section(s) moved to the front. Rows with
// an empty position are skipped (they cannot be labelled). Departments are
// taken verbatim from the row they are attached to.
export const buildStructure = (rows) => {
    const withPosition = (rows || []).filter(
        (r) => r && r.position_uz && r.position_uz.trim() !== ""
    );
    const sections = withPosition.map((r) => ({
        ...r,
        isMainRector: isMainRector(r),
        departments: Array.isArray(r.departments) ? r.departments : [],
    }));
    return [
        ...sections.filter((s) => s.isMainRector),
        ...sections.filter((s) => !s.isMainRector),
    ];
};
